/* eslint-disable-next-line */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import LayoutActions from '../../../reducers/layoutRedux'
import UrlParamsUtil from '../../../utils/UrlParamsUtil'

/**
 * Used to initialize the language for the current user. This will attempt to retrieve the 
 * language parameter from the url search params first, then from the browser. Lastly, it will
 * fallback to English as a default if nothing can be determined from either the url or the browser
 * @param {any} props
 */
const LangInitializer = ({ updateState }) => {
    const dispatch = useDispatch()
    const stateLang = useSelector(state => state.layout.lang);

    const readLangFromCookies = () => {
        if (!document.cookie) return null;
    
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [rawKey, ...rest] = cookie.trim().split('=');
            if (rawKey === 'langPref') {
                const value = rest.join('=');
                return decodeURIComponent(value.trim());
            }
        }
        return null;
    };
    

    const getBrowserDefaultLanguage = () => {
        var browserLang = navigator.languages
            ? navigator.languages[0]
            : (navigator.language || navigator.userLanguage)

        var lang = browserLang.startsWith('fr') ? 'fr' : 'en';

        if (lang) {
            if (lang.toLowerCase().indexOf('fr') !== -1) {
                lang = 'fr'
            } else if (lang.toLowerCase().indexOf('en') !== -1) {
                lang = 'en'
            }
        }
        return lang
    }

    useEffect(() => {
        var lang = null
        var params = UrlParamsUtil.getQueryParams(window.location.search);
        var cookieLang = readLangFromCookies();
        var savedLang = localStorage.getItem('app_language');

        if (params.lang) {
            lang = params.lang.toLowerCase();
        } else if (savedLang) {
            lang = savedLang;
        } else if (cookieLang) {
            lang = cookieLang;
        } else {
            lang = getBrowserDefaultLanguage();
        }
                if (stateLang !== lang) {
            dispatch(LayoutActions.setDictLanguage(lang || 'en'));
        } else {
            dispatch(LayoutActions.setDictLanguage(stateLang))
        }

        updateState(true)
    }, [])

    return null
}

LangInitializer.propTypes = {
    updateState: PropTypes.func.isRequired
}

export default LangInitializer;